<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="ACKNOWLEDGMENTS">
<p class="h2" id="ack"><span class="right_1" epub:type="pagebreak" id="page_xii" title="xii"><span class="right_1" epub:type="pagebreak" id="page_xiii" title="xiii"><a href="#/text/9780253049896_Contents#rack">ACKNOWLEDGMENTS</a></span></span></p>
<p class="imagef"><img alt="" src="images/line.jpg"/></p>
<p class="noindent"><span class="small">ALL ACADEMIC BOOKS ARE THE RESULT OF OUTSIDE ASSISTANCE. THIS</span> history of the Chicago, Rock &amp; Pacific Railroad is no exception. Help came from the John W. Barriger III National Railroad Library, Chicago History Center, Cooper Library Interlibrary Loan Department at Clemson University, Library of Congress, National Archives, Rock Island County Historical Society, Windsor Chamber of Commerce, and from these individuals: Judith Anderson, F. D. Brosnan, Tom Brugman, Keith Bryant, Josh Catalano, Stephen Dock, Jim Farrell, Henry Frick, Nick Fry, Michael Hibblen, Bill Hoenig, Don Hofsommer, Tom Koglin, Bob Lipka, Scott Lothes, Ron Lundstrum, Louis Marre, Craig Myers, Dennis Opforman, David Pfeiffer, William Pollard, Henry Posner III, Eric Rasmussen, Rich Saunders, Ben Safourek, and George Werner. Dan Sabin deserves special recognition, having most of all taken time to supply a large number of illustrations from his vast Rock Island photographic collection.</p>
<p class="indent">A portion of the research stemmed from my earlier publications. These include studies on the Chicago &amp; North Western, Chicago Great Western, Eire Lackawanna, and Wabash Railroads, Railroad Development Corporation, and biographies of John W. Barriger III and Jervis Langdon Jr.</p>
<p class="indent">With my previous books with Indiana University Press, staff members have been professional and supportive through the stages of publication. A generous William D. Middleton Fellowship from the Railway &amp; Locomotive Historical Society aided my research. I also thank the Lemon family who created my Kathryn and Calhoun Lemon Professorship. This financial assistance has continued to advance my scholarly activities.</p>
<p class="noindent1">H. Roger Grant</p>
<p class="noindent">Clemson University</p>
<p class="noindent">Clemson, South Carolina</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253049896_Ack.vue?0abe09d4